<template src="./code.html"></template>
  <script>
import AppSetting from '../../../../AppSetting';
import Base64 from '../../../../plugin/extendFn/Base64';
import loginService from '../../../../plugin/extendFn/loginService';
/**
 * 分享二维码
 */
export default {
  data() {
    return {
      loading:false,
      code: null,
      state: null,
    };
  },
  props: {},
  methods: {
    loginByCode() {
      /**
       * 1.根据 code 获取 openId
       */
      this.loading=true;
      this.$postHttp(AppSetting.baseUrl + "/weixin-login/loginByCode", {
        isWeixinBrowser: loginService.isWeixinBrowser(),  // 是否是微信浏览器
        code:this.code  // 请求码!
      }).then(async (res) => {
        if (res.data.code == 0) {
          var student = res.data.data;
          await loginService.setLoginUser(student);
          this.topTips("登录成功!");
          window.location.href=this.state ; // 跳转到进入页面。 
        }
        else{
          this.topTips(res.data.msg);
        }
      })
      .catch(error=>{
        this.topTips("微信登录失败!");
      })
      .finally(()=>{
        this.loading=false;
    })
    },
  },
  computed: {},
  async mounted() {
    this.code = this.$route.query.code;
    this.state = Base64.decode(this.$route.query.state);
    console.log("this.code >> ", this.code);
    console.log("this.state >> ", this.state);

    if (this.code && this.state) {
      this.loginByCode();
    } else {
      this.topTips("微信登录失败!");
    }
  },
};
</script>
  <style scoped lang="scss" src="./code.scss">
</style>
  


// WEBPACK FOOTER //
// src/components/login/weixinLogin/code/code.vue